import React from 'react'

import NewTag from 'components/Icons/New-Tag-Shadow.svg'

import { Container } from './NewCallout.styled'

function NewCallout() {
    return (
        <Container>
            <img src={NewTag} alt="New" />
        </Container>
    )
}
export default NewCallout
